var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconElPrecioLoPonesTu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 42c-7.747 0-14-6.277-14-14 0-7.747 6.253-14 14-14a14 14 0 010 28zM9.333 30.333a2.333 2.333 0 110-4.666 2.333 2.333 0 010 4.666zM51.333 7h-33.53c-1.54 0-2.916.747-3.803 1.89L0 28l14 19.087C14.887 48.253 16.263 49 17.803 49h33.53A4.667 4.667 0 0056 44.333V11.667C56 9.077 53.9 7 51.333 7zm-21 18.667a2.333 2.333 0 100-4.666 2.333 2.333 0 000 4.666zM35 37.333c4.34 0 7.817-2.986 8.867-7H26.133c1.05 4.014 4.527 7 8.867 7zm4.667-11.666a2.333 2.333 0 100-4.667 2.333 2.333 0 000 4.667z",
    fill: "#54DCF2"
  })));
}
export default SvgIconElPrecioLoPonesTu;